export const LISTAR_SETORES = "LISTAR_SETORES";
export const LISTAR_SETORES_ATUALIZAR_CATALOGO =
  "LISTAR_SETORES_ATUALIZAR_CATALOGO";
export const LISTAR_SETORES_ERRO = "LISTAR_SETORES_ERRO";
export const FETCH_SETORES_CATALOGO = "FETCH_SETORES_CATALOGO";
export const FETCH_SETOR = "FETCH_SETOR";
export const REMOVE_SETOR = "REMOVE_SETOR";
export const EDIT_SETOR_CLIENTE = "EDIT_SETOR_CLIENTE";
